<template>
  <div v-if="program">
    <div class="card-container" @click="linkTo('programa-individual')">
      <div class="image-container">
        <img v-if="program.webImg === null" src="@/assets/class1.png" alt="Clase Principiante" class="card-image" />
        <img style="width: 100%; height: 6.972vw" v-else :src="url + `/program-image/${program.id}/${program.webImg}`"
          alt="">
      </div>
      <div class="content-container">
        <div class="content-header">
          <h3 class="card-title">{{ program.title }}</h3>
          <span v-if="!program.locked" class="like-button" @click.stop="updateLike(program)">
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
              <mask id="mask0_4_125" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="38"
                height="38">
                <rect width="37.7143" height="37.7143" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_4_125)">
                <path
                  d="M18.8572 31.942L17.1227 30.3828C14.5178 28.0196 12.3636 25.9889 10.6602 24.2907C8.95677 22.5923 7.60691 21.0807 6.61063 19.756C5.61434 18.4315 4.91833 17.2232 4.52259 16.1311C4.12659 15.0392 3.92859 13.9312 3.92859 12.8071C3.92859 10.577 4.68052 8.7099 6.18437 7.20578C7.68849 5.70192 9.55561 4.95 11.7857 4.95C13.1576 4.95 14.454 5.27083 15.675 5.9125C16.896 6.55416 17.9567 7.47437 18.8572 8.67311C19.7576 7.47437 20.8183 6.55416 22.0393 5.9125C23.2603 5.27083 24.5567 4.95 25.9286 4.95C28.1587 4.95 30.0258 5.70192 31.5299 7.20578C33.0338 8.7099 33.7857 10.577 33.7857 12.8071C33.7857 13.9312 33.5877 15.0392 33.1917 16.1311C32.796 17.2232 32.1 18.4315 31.1037 19.756C30.1074 21.0807 28.76 22.5923 27.0616 24.2907C25.3634 25.9889 23.2067 28.0196 20.5916 30.3828L18.8572 31.942ZM18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7139 31.4286 12.8071C31.4286 11.2357 30.9048 9.92619 29.8572 8.87857C28.8095 7.83095 27.5 7.30714 25.9286 7.30714C24.6877 7.30714 23.5408 7.65914 22.4879 8.36314C21.4354 9.0674 20.6018 10.0471 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.0547 15.2185 8.35568C14.1709 7.65665 13.0266 7.30714 11.7857 7.30714C10.2243 7.30714 8.91722 7.83095 7.86462 8.87857C6.81203 9.92619 6.28573 11.2357 6.28573 12.8071C6.28573 13.7139 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74288 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.543 16.3429 26.4846 18.8572 28.7571Z"
                  fill="white" />
              </g>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none"
              :class="{ 'like-active': !program.liked }">
              <mask id="mask0_4_124" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="38"
                height="38">
                <rect width="37.7143" height="37.7143" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_4_124)">
                <path
                  d="M18.8572 31.942L17.1227 30.3828C14.5178 28.0196 12.3636 25.9889 10.6602 24.2907C8.95677 22.5923 7.60691 21.0807 6.61062 19.756C5.61434 18.4315 4.91833 17.2232 4.52259 16.1311C4.12659 15.0392 3.92859 13.9312 3.92859 12.8071C3.92859 10.577 4.68052 8.7099 6.18437 7.20578C7.68849 5.70193 9.55561 4.95 11.7857 4.95C13.1576 4.95 14.454 5.27083 15.675 5.9125C16.896 6.55416 17.9567 7.47437 18.8572 8.67311C19.7576 7.47437 20.8183 6.55416 22.0393 5.9125C23.2603 5.27083 24.5567 4.95 25.9286 4.95C28.1587 4.95 30.0258 5.70193 31.5299 7.20578C33.0338 8.7099 33.7857 10.577 33.7857 12.8071C33.7857 13.9312 33.5877 15.0392 33.1917 16.1311C32.796 17.2232 32.1 18.4315 31.1037 19.756C30.1074 21.0807 28.76 22.5923 27.0616 24.2907C25.3634 25.9889 23.2067 28.0196 20.5916 30.3828L18.8572 31.942ZM18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7139 31.4286 12.8071C31.4286 11.2357 30.9048 9.92619 29.8572 8.87857C28.8095 7.83095 27.5 7.30714 25.9286 7.30714C24.6877 7.30714 23.5408 7.65914 22.4879 8.36314C21.4354 9.0674 20.6018 10.0471 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.0547 15.2185 8.35568C14.1709 7.65665 13.0266 7.30714 11.7857 7.30714C10.2243 7.30714 8.91722 7.83095 7.86462 8.87857C6.81203 9.92619 6.28573 11.2357 6.28573 12.8071C6.28573 13.7139 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74287 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.543 16.3429 26.4846 18.8572 28.7571Z"
                  fill="white" />
                <path
                  d="M18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7138 31.4286 12.8071C31.4286 11.2357 30.9048 9.92617 29.8572 8.87855C28.8095 7.83093 27.5 7.30712 25.9286 7.30712C24.6877 7.30712 23.5408 7.65913 22.4879 8.36313C21.4354 9.06739 20.6018 10.047 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.05468 15.2185 8.35566C14.1709 7.65664 13.0266 7.30712 11.7857 7.30712C10.2243 7.30712 8.91722 7.83093 7.86462 8.87855C6.81203 9.92617 6.28573 11.2357 6.28573 12.8071C6.28573 13.7138 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74287 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.5429 16.3429 26.4846 18.8572 28.7571Z"
                  fill="#FF3EA6" />
              </g>
            </svg>
          </span>
        </div>
        <p class="card-description"> {{ program.shortDescr }}</p>
        <p class="card-date">{{ program.createdAt | formatDate }}</p>
      </div>
    </div>


    <div v-if="regLoading" class="loaderView">
      <div>
        <div class="loaderSpinner"></div>
        <p class="process">{{ process }}</p>
      </div>
    </div>

  </div>
</template>

<script>
import dayjs from 'dayjs';
import { url } from "@/global/index"
import { mapActions } from 'vuex';
export default {
  name: "CardsWrapper",
  props: {
    program: {
      type: Object,
      default: false
    },
    section: {
      type: String,
      default: false
    }
  },
  data() {
    return {
      liked: false,
      url,
      regLoading: false,
      process: "",
    };
  },
  methods: {
    ...mapActions("program", ["addItemPgr", "deleteItemPgr", "getAllInfoPgr"]),
    ...mapActions("programcollabs", ["getAllInfoPgrc"]),
    ...mapActions("programrel", ["getAllInfoPgrr"]),
    async updateLike(item) {
      this.regLoading = true
      if (item.liked) {
        await this.deleteItemPgr({
          option: 'like',
          id: item.id,
          subvalue: 'program'
        })
      } else {
        await this.addItemPgr({
          option: 'like',
          item: {
            type: 'program',
            entityId: item.id
          }
        })
      }

      await this.updateAll()

    },
    async updateAll() {
      if (this.section === 'relevantes') {
        await this.getAllInfoPgrr("program/paginated?pageSize=100&categories=41") //pendiente paginar y filtrar
      } else if (this.section === 'colaboraciones') {
        await this.getAllInfoPgrc("program/paginated?pageSize=100&categories=42") //pendiente paginar y filtrar
      } else {
        await this.getAllInfoPgr("program/paginated?pageSize=100") //pendiente paginar y filtrar
      }
      this.regLoading = false
    },

    linkTo(enlace) {
      localStorage.setItem('program', JSON.stringify(this.program))

      const query = enlace;
      if (query) {
        const currentQuery = this.$route.query.a;

        // Verifica si la búsqueda actual es la misma que la nueva búsqueda
        if (query !== currentQuery) {
          this.$router.push({ path: "/web-app", query: { a: query } });
        } else {
          console.log("Ya te encuentras en este enlace");
        }
      } else {
        console.log("No se recibio link");
      }
    },
  },
  filters: {
    formatDate(value) {
      return dayjs(value).format('DD/MM/YYYY')
    },
    formatHour(value) {
      return dayjs(value).format('HH:mm A')
    }
  }
};
</script>

<style scoped>
/* Botón de "Me gusta" */
.like-button {
  display: flex;
  position: relative;
  flex-direction: row;
  padding-right: 0.6944vw;
  cursor: pointer;
}

.like-button svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 0.3s ease;
  width: 1.8056vw;
  height: 1.7361vw;
}

.like-active {
  opacity: 0;
}

/* Contenedor principal de la tarjeta */
.card-container {
  position: relative;
  width: 15.4861vw;
  border-radius: 1.0417vw;
  overflow: hidden;
  box-shadow: 0 0.2778vw 0.4167vw rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

/* Contenedor de la imagen */
.image-container {
  overflow: hidden;
  display: flex;
}

.image-container img {
  object-fit: cover;
  height: 100%;
  min-height: 10vw;
}

/* Imagen */
.card-image {
  width: 100%;
  height: auto;
  display: block;
}

/* Contenedor de contenido */
.content-container {
  position: relative;
  padding: 0.6944vw;
  display: flex;
  height: 8.3333vw;
  flex-direction: column;
  gap: 0.3472vw;
  box-sizing: border-box;
  background: var(--background-gray, #e3e3e9);
}

/* Estilo del título */
.card-title {
  font-family: Manrope, sans-serif;
  font-size: 0.9722vw;
  font-weight: 600;
  background: linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
}

/* Estilo de la descripción */
.card-description {
  font-family: Manrope, sans-serif;
  font-size: 0.7639vw;
  font-weight: 500;
  color: #464d5b;
  margin: 0.3472vw 0;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

/* Estilo de la fecha */
.card-date {
  position: absolute;
  font-family: Inter, sans-serif;
  font-size: 0.6944vw;
  font-weight: 400;
  color: #464d5b;
  align-self: stretch;
  bottom: .6944vw;
  right: .6944vw;
}

/* Encabezado del contenido */
.content-header {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  padding: 0 0.6944vw 0 0;
}

@media (max-width: 530px) {
  .card-container {
    width: 44.375vw;
    height: auto;
    border-radius: 5vw;
  }

  .image-container img {
    height: 100%;
    min-height: 37vw;
  }

  .card-title {
    font-size: 3.25vw;
  }

  .like-button {
    display: flex;
    position: relative;
    flex-direction: row;
    padding-right: 0.6944vw;
    cursor: pointer;
  }

  .like-button svg {
    position: absolute;
    top: 30%;
    left: -50%;
    transform: translate(-50%, -50%);
    transition: opacity 0.3s ease;
    width: 5vw;
    height: 5vw;
  }

  .card-description {
    -webkit-line-clamp: 2;
    font-size: 2.5vw;
  }

  .card-date {
    font-size: 2vw;
    right: 2.2727vw;
    bottom: 2.2727vw;
  }

  .content-container {
    height: 23.4091vw;
    padding: 2.5vw;
  }
}
</style>
